<template>
  <v-navigation-drawer
    v-model="drawer"
    class="colorDominant grey darken-3 colorMenuLeftTheme"
    clipped
    app
  >
    <div v-if="data.length > 0" style="padding-bottom: 200px;">
      <v-list
        v-for="(menu, index) in data"
        :key="index"
        :expand="true"
        dense
        nav
      >
        <v-subheader class="overline">{{ menu.name }}</v-subheader>

        <v-list-item
          :to="{
            name: 'casinoLobby',
            params: { casinoType: menu.type },
          }"
          :color="colorActiveByTypeCasino(menu.type)"
          :exact-path="true"
        >
          <v-list-item-icon>
            <v-icon>{{ iconByTypeCasino[menu.type] }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="d-flex text-truncate">
              <v-list-item-title :title="`Lobby ${menu.name}`">
                Lobby
              </v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{
            name: 'casinoProviders',
            params: { casinoType: menu.type },
          }"
          :color="colorActiveByTypeCasino(menu.type)"
        >
          <v-list-item-icon>
            <v-icon>mdi-cards</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="d-flex text-truncate">
              <v-list-item-title
                :title="`${$t('newCasino.providers')} ${menu.name}`"
              >
                {{ $t('newCasino.providers') }}
              </v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="$store.state.logged.status"
          :to="{
            name: 'casinoFavorites',
            params: { casinoType: menu.type },
          }"
          :color="colorActiveByTypeCasino(menu.type, true)"
        >
          <v-list-item-icon>
            <v-icon>mdi-star</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="d-flex text-truncate">
              <v-list-item-title
                :title="`${$t('favorites')} ${menu.name}`"
              >
                {{ $t('favorites') }}
              </v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          append-icon="mdi-menu-down"
          :color="colorActiveByTypeCasino(menu.type)"
          :value="true"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title
                class="d-flex align-center text-capitalize"
              >
                <span>{{ $t("newCasino.categories") }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <div v-for="(category, index) in menu.categories" :key="index">
            <v-list-item
              v-if="category.qtd_games > 0"
              :to="{
                name: 'casinoCategory',
                params: {
                  casinoType: menu.type === 'live' ? 'live' : 'casino',
                  category: category.name,
                },
              }"
            >
              <v-list-item-content>
                <div class="d-flex text-truncate">
                  <v-list-item-title :title="category.name">
                    {{ category.name }}
                  </v-list-item-title>
                  <v-list-item-avatar
                    size="24"
                    class="ma-0"
                    style="background-color: rgba(0, 0, 0, 0.2)"
                  >
                  <span style="font-size: 10px">{{ category.qtd_games }}</span>
                  </v-list-item-avatar>
                </div>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-group>
        
        <v-divider
          v-if="index !== data.length - 1"
          class="mt-4 mb-n4"
        ></v-divider>
      </v-list>
    </div>

    <div v-else class="d-flex justify-center pt-6">
      <v-progress-circular
        :size="32"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "LeftMenuCasino",

  props: ["drawer_prop"],

  data: (vm) => ({
    drawer: null,
    data: vm.$store.state.casinoLeftMenu,
    menuActive: {
      casino: false,
      live: false,
    },
    iconByTypeCasino: {
      casino: "mdi-slot-machine-outline",
      live: "mdi-cards-club",
    },
  }),

  created() {
    this.fetchLeftMenu();
  },

  computed: {
    storeLeftMenu() {
      return this.$store.state.casinoLeftMenu;
    },
  },

  watch: {
    storeLeftMenu(val) {
      this.data = val;
    },
    // Abertura do Drawer (recebendo por prop)
    drawer_prop(val) {
      this.drawer = val;
    },
    // Fechamento do Drawer
    drawer(newVal) {
      this.$emit("update:drawer", newVal);
    },
  },

  methods: {
    fetchLeftMenu() {
      const body = {
        domain: this.$domain(),
      };

      const { isExpired, data } = this.$casinoStorage.get({
        type: "casinoLeftMenu",
      });

      if (isExpired === false && data.leftMenu) {
        this.data = data.leftMenu;
        this.$store.commit("setCasinoLeftMenu", data.leftMenu);
        return;
      }

      this.$axios
        .post("casino/gamesAgregation/getLeftMenuCassino", this.$formdata(body))
        .then((res) => {
          const data = res.data.dados;

          const casinoCategories = [];
          const liveCategories = [];
          let casinoGames = 0;
          let liveGames = 0;
          const hasLiveCasino = this.$store.state.operators.casino == "2";

          for (const type in data) {
            data[type].forEach((category) => {
              if (type === "live" && hasLiveCasino) {
                liveCategories.push(category);
                liveGames += Number(category.qtd_games);
              } else {
                casinoCategories.push(category);
                casinoGames += Number(category.qtd_games);
              }
            });
          }

          const leftMenu = [
            {
              name: this.$t("casino"),
              type: "casino",
              numberOfGames: casinoGames,
              categories: casinoCategories,
            },
          ];

          if (hasLiveCasino) {
            leftMenu.push({
              name: this.$t("liveCasino"),
              type: "live",
              numberOfGames: liveGames,
              categories: liveCategories,
            });
          }

          this.data = leftMenu;

          this.$casinoStorage.set({
            type: "casinoLeftMenu",
            fields: { leftMenu },
          });

          this.$store.commit("setCasinoLeftMenu", leftMenu);
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        });
    },
    colorActiveByTypeCasino(typeCasino, isFavorite) {
      if (!this.$store.state.logged.status && isFavorite) return "";

      const typeCasinoRoute = this.$route.params.casinoType;
      return typeCasino == typeCasinoRoute ? "primary" : "white";
    },
  },
};
</script>
